module.exports = __webpack_public_path__ + "img/wc_logo.778def55.jpg";